import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KClass1cc9rfeybg8hs as KClass } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KClassJs.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  KtList3hktaavzmj137 as KtList,
  Entry2xmjmyutzoq3p as Entry,
  KtMap140uvy3s5zad8 as KtMap,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  KtSetjrjc7fhfd6b9 as KtSet,
  KtMutableSetwuwn7k5m570a as KtMutableSet,
  Collection1k04j3hzsbod0 as Collection,
  KtMutableList1beimitadwkna as KtMutableList,
} from '../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import {
  platformSpecificSerializerNotRegistered35vpw6xk2l454 as platformSpecificSerializerNotRegistered,
  compiledSerializerImpl2ykwhos63n897 as compiledSerializerImpl,
  isInterface150ul88kmyj8d as isInterface_0,
  isReferenceArray1zykjthfz743b as isReferenceArray,
  constructSerializerForGivenTypeArgsj1zk005on26m as constructSerializerForGivenTypeArgs,
} from './internal/Platform.mjs';
import { builtinSerializerOrNull180kp99qvlpex as builtinSerializerOrNull } from './internal/Primitives.mjs';
import { EmptySerializersModule991ju6pz9b79 as EmptySerializersModule } from './modules/SerializersModuleBuilders.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from './SerializationExceptions.mjs';
import { IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException } from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from './KSerializer.mjs';
import {
  kclass1exqpscvro86a as kclass,
  typeOrThrowwmzfq0bqyfgr as typeOrThrow,
} from './internal/Platform.common.mjs';
import {
  get_nullable197rfua9r7fsz as get_nullable,
  ArraySerializermpxy3fgi5xnb as ArraySerializer,
  TripleSerializer39fneesmgp1wy as TripleSerializer,
  PairSerializer1d18kmsqyj4f as PairSerializer,
  MapEntrySerializer3oe1sx5ozvw2u as MapEntrySerializer,
} from './builtins/BuiltinSerializers.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  findParametrizedCachedSerializer1zrxdjq0nix5d as findParametrizedCachedSerializer,
  findCachedSerializer3o8gql85ngyfi as findCachedSerializer,
} from './SerializersCache.mjs';
import {
  _Result___get_value__impl__bjfvqg9vwgdwmhxc4m as _Result___get_value__impl__bjfvqg,
  _Result___get_isFailure__impl__jpiriv2yxkms7bg2hpm as _Result___get_isFailure__impl__jpiriv,
} from '../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { PolymorphicSerializer3p3fzpdobi8hh as PolymorphicSerializer } from './PolymorphicSerializer.mjs';
import {
  Triple1vhi3d0dgpnjb as Triple,
  Paire9pteg33gng7 as Pair,
} from '../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  LinkedHashMapSerializermaoj2nyji7op as LinkedHashMapSerializer,
  HashMapSerializer10v33y6rrzgrh as HashMapSerializer,
  LinkedHashSetSerializer3ncla559t2lx7 as LinkedHashSetSerializer,
  HashSetSerializer1nieavib0jif1 as HashSetSerializer,
  ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer,
} from './internal/CollectionSerializers.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { LinkedHashSet2tkztfx86kyx2 as LinkedHashSet } from '../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashSet.mjs';
import { HashSet2dzve9y63nf0v as HashSet } from '../../../kotlin-kotlin-stdlib/kotlin/collections/HashSet.mjs';
import { copyToArray2j022khrow2yi as copyToArray } from '../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function serializer(_this__u8e3s4, kClass, typeArgumentsSerializers, isNullable) {
  var tmp = isInterface(kClass, KClass()) ? kClass : THROW_CCE();
  var tmp0_elvis_lhs = serializerByKClassImpl(_this__u8e3s4, tmp, isInterface(typeArgumentsSerializers, KtList()) ? typeArgumentsSerializers : THROW_CCE(), isNullable);
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    platformSpecificSerializerNotRegistered(kClass);
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  return tmp_0;
}
function serializerOrNull(_this__u8e3s4) {
  var tmp0_elvis_lhs = compiledSerializerImpl(_this__u8e3s4);
  return tmp0_elvis_lhs == null ? builtinSerializerOrNull(_this__u8e3s4) : tmp0_elvis_lhs;
}
function serializer_0(kClass, typeArgumentsSerializers, isNullable) {
  return serializer(EmptySerializersModule(), kClass, typeArgumentsSerializers, isNullable);
}
function serializerByKClassImpl(_this__u8e3s4, rootClass, typeArgumentsSerializers, isNullable) {
  var tmp;
  if (typeArgumentsSerializers.isEmpty_y1axqb_k$()) {
    var tmp0_elvis_lhs = serializerOrNull(rootClass);
    tmp = tmp0_elvis_lhs == null ? _this__u8e3s4.getContextual$default_5chm2b_k$(rootClass) : tmp0_elvis_lhs;
  } else {
    var tmp_0;
    try {
      var tmp1_elvis_lhs = parametrizedSerializerOrNull(rootClass, typeArgumentsSerializers, serializerByKClassImpl$lambda);
      tmp_0 = tmp1_elvis_lhs == null ? _this__u8e3s4.getContextual_lmiski_k$(rootClass, typeArgumentsSerializers) : tmp1_elvis_lhs;
    } catch ($p) {
      var tmp_1;
      if ($p instanceof IndexOutOfBoundsException()) {
        var e = $p;
        throw SerializationException().new_kotlinx_serialization_SerializationException_pjmzgo_k$('Unable to retrieve a serializer, the number of passed type serializers differs from the actual number of generic parameters', e);
      } else {
        throw $p;
      }
    }
    tmp = tmp_0;
  }
  var serializer = tmp;
  var tmp_2;
  if (serializer == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlinx.serialization.internal.cast' call
    tmp_2 = isInterface(serializer, KSerializer()) ? serializer : THROW_CCE();
  }
  var tmp3_safe_receiver = tmp_2;
  return tmp3_safe_receiver == null ? null : nullable(tmp3_safe_receiver, isNullable);
}
function serializer_1(type) {
  return serializer_2(EmptySerializersModule(), type);
}
function serializer_2(_this__u8e3s4, type) {
  var tmp0_elvis_lhs = serializerByKTypeImpl(_this__u8e3s4, type, true);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    platformSpecificSerializerNotRegistered(kclass(type));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function parametrizedSerializerOrNull(_this__u8e3s4, serializers, elementClassifierIfArray) {
  var tmp0_elvis_lhs = builtinParametrizedSerializer(_this__u8e3s4, serializers, elementClassifierIfArray);
  return tmp0_elvis_lhs == null ? compiledParametrizedSerializer(_this__u8e3s4, serializers) : tmp0_elvis_lhs;
}
function nullable(_this__u8e3s4, shouldBeNullable) {
  if (shouldBeNullable)
    return get_nullable(_this__u8e3s4);
  return isInterface(_this__u8e3s4, KSerializer()) ? _this__u8e3s4 : THROW_CCE();
}
function serializerByKTypeImpl(_this__u8e3s4, type, failOnMissingTypeArgSerializer) {
  var rootClass = kclass(type);
  var isNullable = type.get_isMarkedNullable_4el8ow_k$();
  // Inline function 'kotlin.collections.map' call
  var this_0 = type.get_arguments_p5ddub_k$();
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var item = _iterator__ex2g4s.next_20eer_k$();
    var tmp$ret$2 = typeOrThrow(item);
    destination.add_utx5q5_k$(tmp$ret$2);
  }
  var typeArguments = destination;
  var tmp;
  if (typeArguments.isEmpty_y1axqb_k$()) {
    var tmp_0;
    if (isInterface_0(rootClass) && !(_this__u8e3s4.getContextual$default_5chm2b_k$(rootClass) == null)) {
      tmp_0 = null;
    } else {
      tmp_0 = findCachedSerializer(rootClass, isNullable);
    }
    tmp = tmp_0;
  } else {
    var tmp_1;
    if (_this__u8e3s4.get_hasInterfaceContextualSerializers_ia3ak6_k$()) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.Result.getOrNull' call
      var this_1 = findParametrizedCachedSerializer(rootClass, typeArguments, isNullable);
      tmp_1 = _Result___get_isFailure__impl__jpiriv(this_1) ? null : _Result___get_value__impl__bjfvqg(this_1);
    }
    tmp = tmp_1;
  }
  var cachedSerializer = tmp;
  if (!(cachedSerializer == null))
    return cachedSerializer;
  var tmp_2;
  if (typeArguments.isEmpty_y1axqb_k$()) {
    var tmp0_elvis_lhs = serializerOrNull(rootClass);
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? _this__u8e3s4.getContextual$default_5chm2b_k$(rootClass) : tmp0_elvis_lhs;
    var tmp_3;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlinx.serialization.polymorphicIfInterface' call
      tmp_3 = isInterface_0(rootClass) ? PolymorphicSerializer().new_kotlinx_serialization_PolymorphicSerializer_2rg7t_k$(rootClass) : null;
    } else {
      tmp_3 = tmp1_elvis_lhs;
    }
    tmp_2 = tmp_3;
  } else {
    var tmp2_elvis_lhs = serializersForParameters(_this__u8e3s4, typeArguments, failOnMissingTypeArgSerializer);
    var tmp_4;
    if (tmp2_elvis_lhs == null) {
      return null;
    } else {
      tmp_4 = tmp2_elvis_lhs;
    }
    var serializers = tmp_4;
    var tmp3_elvis_lhs = parametrizedSerializerOrNull(rootClass, serializers, () => typeArguments.get_c1px32_k$(0).get_classifier_ottyl2_k$());
    var tmp4_elvis_lhs = tmp3_elvis_lhs == null ? _this__u8e3s4.getContextual_lmiski_k$(rootClass, serializers) : tmp3_elvis_lhs;
    var tmp_5;
    if (tmp4_elvis_lhs == null) {
      // Inline function 'kotlinx.serialization.polymorphicIfInterface' call
      tmp_5 = isInterface_0(rootClass) ? PolymorphicSerializer().new_kotlinx_serialization_PolymorphicSerializer_2rg7t_k$(rootClass) : null;
    } else {
      tmp_5 = tmp4_elvis_lhs;
    }
    tmp_2 = tmp_5;
  }
  var contextualSerializer = tmp_2;
  var tmp_6;
  if (contextualSerializer == null) {
    tmp_6 = null;
  } else {
    // Inline function 'kotlinx.serialization.internal.cast' call
    tmp_6 = isInterface(contextualSerializer, KSerializer()) ? contextualSerializer : THROW_CCE();
  }
  var tmp6_safe_receiver = tmp_6;
  return tmp6_safe_receiver == null ? null : nullable(tmp6_safe_receiver, isNullable);
}
function builtinParametrizedSerializer(_this__u8e3s4, serializers, elementClassifierIfArray) {
  var tmp;
  if (_this__u8e3s4.equals(getKClass(Collection())) || _this__u8e3s4.equals(getKClass(KtList())) || (_this__u8e3s4.equals(getKClass(KtMutableList())) || _this__u8e3s4.equals(getKClass(ArrayList())))) {
    tmp = new (ArrayListSerializer())(serializers.get_c1px32_k$(0));
  } else if (_this__u8e3s4.equals(getKClass(HashSet()))) {
    tmp = new (HashSetSerializer())(serializers.get_c1px32_k$(0));
  } else if (_this__u8e3s4.equals(getKClass(KtSet())) || (_this__u8e3s4.equals(getKClass(KtMutableSet())) || _this__u8e3s4.equals(getKClass(LinkedHashSet())))) {
    tmp = new (LinkedHashSetSerializer())(serializers.get_c1px32_k$(0));
  } else if (_this__u8e3s4.equals(getKClass(HashMap()))) {
    tmp = new (HashMapSerializer())(serializers.get_c1px32_k$(0), serializers.get_c1px32_k$(1));
  } else if (_this__u8e3s4.equals(getKClass(KtMap())) || (_this__u8e3s4.equals(getKClass(KtMutableMap())) || _this__u8e3s4.equals(getKClass(LinkedHashMap())))) {
    tmp = new (LinkedHashMapSerializer())(serializers.get_c1px32_k$(0), serializers.get_c1px32_k$(1));
  } else if (_this__u8e3s4.equals(getKClass(Entry()))) {
    tmp = MapEntrySerializer(serializers.get_c1px32_k$(0), serializers.get_c1px32_k$(1));
  } else if (_this__u8e3s4.equals(getKClass(Pair()))) {
    tmp = PairSerializer(serializers.get_c1px32_k$(0), serializers.get_c1px32_k$(1));
  } else if (_this__u8e3s4.equals(getKClass(Triple()))) {
    tmp = TripleSerializer(serializers.get_c1px32_k$(0), serializers.get_c1px32_k$(1), serializers.get_c1px32_k$(2));
  } else {
    var tmp_0;
    if (isReferenceArray(_this__u8e3s4)) {
      var tmp_1 = elementClassifierIfArray();
      tmp_0 = ArraySerializer((!(tmp_1 == null) ? isInterface(tmp_1, KClass()) : false) ? tmp_1 : THROW_CCE(), serializers.get_c1px32_k$(0));
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function compiledParametrizedSerializer(_this__u8e3s4, serializers) {
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$0 = copyToArray(serializers);
  return constructSerializerForGivenTypeArgs(_this__u8e3s4, tmp$ret$0.slice());
}
function serializersForParameters(_this__u8e3s4, typeArguments, failOnMissingTypeArgSerializer) {
  var tmp;
  if (failOnMissingTypeArgSerializer) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(typeArguments, 10));
    var _iterator__ex2g4s = typeArguments.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s.next_20eer_k$();
      var tmp$ret$2 = serializer_2(_this__u8e3s4, item);
      destination.add_utx5q5_k$(tmp$ret$2);
    }
    tmp = destination;
  } else {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(typeArguments, 10));
    var _iterator__ex2g4s_0 = typeArguments.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
      var item_0 = _iterator__ex2g4s_0.next_20eer_k$();
      var tmp0_elvis_lhs = serializerOrNull_0(_this__u8e3s4, item_0);
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        return null;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var tmp$ret$5 = tmp_0;
      destination_0.add_utx5q5_k$(tmp$ret$5);
    }
    tmp = destination_0;
  }
  var serializers = tmp;
  return serializers;
}
function serializerOrNull_0(_this__u8e3s4, type) {
  return serializerByKTypeImpl(_this__u8e3s4, type, false);
}
function serializerByKClassImpl$lambda() {
  throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$('It is not possible to retrieve an array serializer using KClass alone, use KType instead or ArraySerializer factory');
}
//region block: exports
export {
  parametrizedSerializerOrNull as parametrizedSerializerOrNull6qjye9i03zwg,
  serializerOrNull as serializerOrNull294cbc318ws50,
  serializersForParameters as serializersForParameters9udy8uiwybz9,
  serializer_1 as serializer1hwzc6m64v1op,
  serializer as serializer23irjhw2jlmhr,
  serializer_2 as serializer1i4e9ym37oxmo,
  serializer_0 as serializer3pi9q3u39g4ku,
};
//endregion

//# sourceMappingURL=Serializers.mjs.map
